var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button-border-radius outline-none body-font highlight-bg cta-button-case",class:_vm.sm ? 'px-3 py-1 text-sm font-normal ' : 'px-6 py-2 font-bold',attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }